import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=dff11f32"
import script from "./Treatments.vue?vue&type=script&lang=js"
export * from "./Treatments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports